import React from 'react';
import { Formik, Form, Field } from 'formik';

function FormView({ 
    formikRef = () => { }, 
    edit = false, 
    office = {}, 
    groups = [], 
    onSubmit, 
    error, 
    setError, 
    onCancel 
}) {
    return (
        <div className='container mt-3'>
            <Formik
                innerRef={formikRef}
                initialValues={{
                    ...(office || {}),
                    office_groups: office?.office_groups?.map(group => group.group_id) || [],
                    assign_group: office?.office_groups?.length > 0 || false,
                }}
                onSubmit={onSubmit}>
                {({ values, setFieldValue, resetForm }) =>
                    <Form>

                        {/* Key */}
                        <div class="mb-3">
                            <div class="form-group">
                                <label class="input">
                                    <Field type="text" name="key" class="form-control input__field" placeholder=" " required value={values.key || ''} />
                                    <span class="input__label">
                                        Clave <span className='text-danger fw-bold'>*</span>
                                    </span>
                                </label>
                            </div>
                        </div>

                        {/* Description */}
                        <div class="mb-3">
                            <div class="form-group">
                                <label class="input">
                                    <Field type="text" name="description" class="form-control input__field" placeholder=" " required value={values.description || ''} />
                                    <span class="input__label">
                                        Descripción <span className='text-danger fw-bold'>*</span>
                                    </span>
                                </label>
                            </div>
                        </div>

                        {/* Abbreviation */}
                        <div class="mb-3">
                            <div class="form-group">
                                <label class="input">
                                    <Field type="text" name="abbreviation" class="form-control input__field" placeholder=" " required value={values.abbreviation || ''} />
                                    <span class="input__label">
                                        Abreviación <span className='text-danger fw-bold'>*</span>
                                    </span>
                                </label>
                            </div>
                        </div>

                        {/* Group */}
                        <div class="mb-2">
                            <div class="form-group">
                                <div className='col d-flex align-items-center'>
                                    <span>Asignar grupos de empleados</span>
                                    <input 
                                        type="checkbox" 
                                        name="assign_group" 
                                        className="mx-2" 
                                        checked={values.assign_group??false} 
                                        onChange={(e) => {
                                            setFieldValue('assign_group', e.target.checked);
                                        }} 
                                    />
                                </div>
                            </div>
                        </div>

                        {values.assign_group && (
                            <div class="mb-3">
                                <div class="form-group" style={{ maxHeight: "30vh", overflowY: "auto" }}>
                                    <table class="table table-sm table-borderless table-thead-bordered table-nowrap table-align-middle card-table dataTable no-footer">
                                        <thead>
                                            <tr role="row">
                                                <th style={{ width: "90%" }}>Seleccionar grupos</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                groups && groups.map((group) =>
                                                    <tr key={group.id}>
                                                        <td>
                                                            {group.key} - {group.description}
                                                        </td>
                                                        <td>
                                                            <div className="custom-control custom-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id={group.id}
                                                                    onChange={() => {
                                                                        const selectedGroups = values.office_groups || [];
                                                                        if (selectedGroups.includes(group.id)) {
                                                                            setFieldValue('office_groups', selectedGroups.filter(id => id !== group.id));
                                                                        } else {
                                                                            setFieldValue('office_groups', [...selectedGroups, group.id]);
                                                                        }
                                                                    }}
                                                                    checked={values.office_groups?.includes(group.id)}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {error ? (
                            <div class="alert alert-danger alert-dismissible fade show d-flex justify-content-between" role="alert">
                                <p className='text-justify' style={{ width: "90%" }}>
                                    {error}
                                </p>
                                <button type="button" class="close" data-dismiss="alert" aria-label="Close" onClick={() => setError(null)}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        ) : null}

                        <div class="pt-3">
                            <button type="submit" class="btn btn-primary">
                                <i class="bi bi-plus" style={{marginRight: "10px"}}></i>
                                {edit ? "Editar sucursal" : "Guardar sucursal"}
                            </button>

                            <button type="button" class="btn btn-danger" style={{ marginLeft: "20px" }} onClick={onCancel.bind(null, resetForm)}>
                                <i class="bi bi-x" style={{marginRight: "10px"}}></i>
                                Cancelar
                            </button>
                        </div>

                    </Form>
                }</Formik>

        </div >
    )
}

export default FormView;